var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatTeardropDotsSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_2054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4688 25.1074H3.625C3.37636 25.1074 3.1379 25.0087 2.96209 24.8328C2.78627 24.657 2.6875 24.4186 2.6875 24.1699V14.3262C2.6875 11.4668 3.82338 8.72455 5.84525 6.70268C7.86713 4.6808 10.6094 3.54492 13.4688 3.54492C14.8846 3.54492 16.2865 3.82379 17.5946 4.3656C18.9026 4.9074 20.0911 5.70155 21.0922 6.70268C22.0934 7.70381 22.8875 8.89232 23.4293 10.2004C23.9711 11.5084 24.25 12.9104 24.25 14.3262C24.25 15.742 23.9711 17.1439 23.4293 18.452C22.8875 19.76 22.0934 20.9485 21.0922 21.9497C20.0911 22.9508 18.9026 23.7449 17.5946 24.2867C16.2865 24.8286 14.8846 25.1074 13.4688 25.1074Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4688 16.2012C14.2454 16.2012 14.875 15.5716 14.875 14.7949C14.875 14.0183 14.2454 13.3887 13.4688 13.3887C12.6921 13.3887 12.0625 14.0183 12.0625 14.7949C12.0625 15.5716 12.6921 16.2012 13.4688 16.2012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3125 16.2012C9.08915 16.2012 9.71875 15.5716 9.71875 14.7949C9.71875 14.0183 9.08915 13.3887 8.3125 13.3887C7.53585 13.3887 6.90625 14.0183 6.90625 14.7949C6.90625 15.5716 7.53585 16.2012 8.3125 16.2012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.625 16.2012C19.4017 16.2012 20.0312 15.5716 20.0312 14.7949C20.0312 14.0183 19.4017 13.3887 18.625 13.3887C17.8483 13.3887 17.2188 14.0183 17.2188 14.7949C17.2188 15.5716 17.8483 16.2012 18.625 16.2012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_2054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatTeardropDotsSvg);
export default __webpack_public_path__ + "static/media/ChatTeardropDotsSVG.35d1b42fea52a7e8c29a2878d6b72fab.svg";
export { ForwardRef as ReactComponent };